import {LayoutSection} from './lib/contentful/types'

import {components} from '@miro-site/components-twig'

const twigComponentsMap = {
  'action/action-3.twig': 'Action3',
  
  'review/review-1.twig': 'Review1',
  'review/review-3.twig': 'Review3',
  'review/review-4.twig': 'Testimonial',

  'slider/slider-3.twig': 'Slider3',

  'promo/templates-promo.twig': 'TemplatesPromo',

  'cta/cta-3.twig': 'Cta3',
  'cta/cta-4.twig': 'Cta4',
  'cta/cta-5.twig': 'CtaWithPattern',
  'cta/cta-6.twig': 'Cta6',

  'feature/feature-3.twig': 'Feature3',

  'form/form-3.twig': 'Form3',

  'content/content-1.twig': 'FAQ',

  'hero/hero-4.twig': 'Hero',
  'hero/hero-5.twig': 'Hero5',
  'hero/hero-6.twig': 'Hero6',
  'hero/hero-8.twig': 'HeroFirstLevel',
  'hero/hero-9.twig': 'HeroSecondLevel',
  'hero/hero-10.twig': 'Hero10',
  'hero/hero-11.twig': 'Hero11',

  'info/info-1.twig': 'Info1',
  'info/info-2.twig': 'OneColumnEmbed',

  'table/table-1.twig': 'Table1',
  'table/table-2.twig': 'Table2',

  'text-block/text-block-1.twig': 'TextBlock1',
  'text-block/text-block-2.twig': 'TextBlock2',
  'text-block/text-block-3.twig': 'TextBlockWithScrollingItems',

  'card/card-1.twig': 'Resources',
  'card/card-5.twig': 'RelatedContent',
}

const isLegacyLayout = (layoutSection: LayoutSection): boolean => {
  return typeof layoutSection.template !== 'undefined'
}

export const getComponentName = (section: LayoutSection): string =>
  isLegacyLayout(section)
    ? twigComponentsMap[`${section.component}/${section.template}`]
    : section.component

export default components
